import React from "react";

import SectionFigure from "./SectionFigure";

export default function ProjectSection(props) {
  return (
    <>
      <section className="section-spacing" id={props.sectionID}>
        <div className="container">
          <h2 className="heading-secondary">{props.sectionHeading}</h2>

          <div className="container-figure">
            <div className="grid grid--2-cols grid--2-rows">
              <SectionFigure
                heading="Ziwy"
                listItem1="Maximize your credit card rewards with an intelligent platform"
                listItem2="Compare rewards across multiple credit cards and find best deals on vouchers"
                listItem3="Get personalized recommendations and instant optimization based on your spending patterns"
                appURL="https://ziwy.in"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
